import type { RootState } from '@/app/store/store'
import { useSelector } from 'react-redux'
import { UserRoles } from '@/shared/utils/types/roles'
import { TestStationRoleRegExps } from '../foxconnUnityRoles'

export const useRole = () => {
  const { roles } = useSelector((state: RootState) => state.user)

  const hasAccess = (requiredRoles: UserRoles[] | UserRoles): boolean => {
    const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles]

    return required.every((role) => roles.some((userRole) => TestStationRoleRegExps[role].test(userRole)))
  }

  const hasAnyAccess = (requiredRoles: UserRoles[] | UserRoles): boolean => {
    const required = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles]

    return required.some((role) => roles.some((userRole) => TestStationRoleRegExps[role].test(userRole)))
  }

  return { hasAccess, hasAnyAccess }
}
